import { overlay } from 'overlay-kit';
import type { ReactNode } from 'react';

import type { VariantProps } from 'class-variance-authority';
import { DefaultDialog } from '../components/default-dialog';
import type { buttonVariants } from '../components/shadcn/button';

export async function showDialog({
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  hideCancel = false,
  confirmVariants,
  cancelVariants,
}: {
  title?: string;
  message?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  hideCancel?: boolean;
  confirmVariants?: VariantProps<typeof buttonVariants>;
  cancelVariants?: VariantProps<typeof buttonVariants>;
}): Promise<void> {
  return overlay.openAsync(({ isOpen, close, unmount }) => (
    <DefaultDialog
      isOpen={isOpen}
      close={close}
      onConfirm={onConfirm}
      onUnmount={unmount}
      onCancel={onCancel}
      title={title}
      message={message ?? ''}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      hideCancel={hideCancel}
      confirmVariants={confirmVariants}
      cancelVariants={cancelVariants}
    />
  ));
}
